<ion-app>
  <ion-split-pane when="web.MenuShow">
    <ion-menu>
      <ion-header class="menu">
        <div class="menu" style="padding:10px">
          <div class="ion-padding" style="text-align:center">
            <img src="assets/imgs/banner.png" alt="logo" style="width:75%" />
          </div>
          {{ 'Welcome, ' }}<br />
          <span><strong>{{ global.GetUser('FirstName') }}</strong></span>
        </div>
      </ion-header>
      <ion-content class="menu">
        <ion-list class="menu">
          <ion-item lines="none" button (click)="Toggle('Main');" class="menu">
            <fa-icon slot="start" [icon]="faAngleRight" size="2x" *ngIf="!Menu['Main']"></fa-icon>
            <fa-icon slot="start" [icon]="faAngleDown" size="2x" *ngIf="Menu['Main']"></fa-icon>
            <ion-label>
              <!-- <fa-icon [icon]="faHome" size="2x"></fa-icon>
              &nbsp; -->
              <strong>{{ 'MAIN' }}</strong>
            </ion-label>
          </ion-item>

          <ion-list *ngIf="Menu['Main']" class="menu">
            <ion-menu-toggle>
              <ion-item lines="none" button (click)="MenuRoute('/dashboard')" class="menu">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faTachometerAlt" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Dashboard' }}</strong>
                </ion-label>
              </ion-item>

              <!-- <ion-item lines="none" button (click)="MenuRoute('/notifications')" class="menu" *ngIf="global.GetUser('Administrator')===true">
                <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faBell" size="2x"></fa-icon>
                <ion-label>
                  <strong>{{ 'Notifications' }}</strong>
                </ion-label>
                <ion-badge color="danger" *ngIf="global.Notification>0">&nbsp;&nbsp;{{ global.Notification }}&nbsp;&nbsp;</ion-badge>
              </ion-item> -->

              <ion-item lines="none" button (click)="MenuRoute('/changepassword')" class="menu" *ngIf="global.GetUser('UsersKey')!=='***admin***'">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faLock" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Change Password' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/settings')" class="menu" *ngIf="global.GetUser('Administrator')===true">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faGalacticRepublic" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'System Settings' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/logout')" class="menu">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faSignOutAlt" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Logout' }}</strong>
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>

          <ion-item lines="none" button (click)="Toggle('Profiles');" class="menu" *ngIf="global.WithModule('UserGroups') || global.WithModule('Users') || global.WithModule('Warehouses') || global.WithModule('Items') || global.WithModule('PriceClasses') || global.WithModule('Areas') || global.WithModule('Customers') || global.WithModule('SpecialPromos') || global.WithModule('Countries') || global.WithModule('Currencies') || global.WithModule('Suppliers') || global.WithModule('Expenses') || global.WithModule('ChartOfAccounts') || global.WithModule('FinancialPeriods') || global.WithModule('Stores')">
            <fa-icon slot="start" [icon]="faAngleRight" size="2x" *ngIf="!Menu['Profiles']"></fa-icon>
            <fa-icon slot="start" [icon]="faAngleDown" size="2x" *ngIf="Menu['Profiles']"></fa-icon>

            <ion-label>
              <!-- <fa-icon [icon]="faUserCircle" size="2x"></fa-icon>
              &nbsp; -->
              <strong>{{ 'PROFILES' }}</strong>
            </ion-label>
          </ion-item>

          <ion-list *ngIf="Menu['Profiles']" class="menu">
            <ion-menu-toggle>
              <ion-item lines="none" button (click)="MenuRoute('/usergroupslist')" class="menu" *ngIf="global.WithModule('UserGroups')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faUsers" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'User Groups' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/userslist')" class="menu" *ngIf="global.WithModule('Users')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faUserSecret" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Users' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/warehouseslist')" class="menu" *ngIf="global.WithModule('Warehouses')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faWarehouse" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Warehouses' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/itemcategorieslist')" class="menu" *ngIf="global.WithModule('Items')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faNetworkWired" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Items' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/priceclasseslist')" class="menu" *ngIf="global.WithModule('PriceClasses')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faDollarSign" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Price Classes' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/areaslist')" class="menu" *ngIf="global.WithModule('Areas')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faMap" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Areas' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/customerslist')" class="menu" *ngIf="global.WithModule('Customers')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faUserTie" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Customers' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/specialpromoslist')" class="menu" *ngIf="global.WithModule('SpecialPromos')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faTags" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Special Promos' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/countrieslist')" class="menu" *ngIf="global.WithModule('Countries')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faGlobe" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Countries' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/currencieslist')" class="menu" *ngIf="global.WithModule('Currencies')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faYenSign" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Currencies' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/supplierslist')" class="menu" *ngIf="global.WithModule('Suppliers')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faUserAlt" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Suppliers' }}</strong>
                </ion-label>
              </ion-item>

              <!-- <ion-item lines="none" button (click)="MenuRoute('/expenseslist')" class="menu" *ngIf="global.WithModule('Expenses')">
                <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faCoins" size="2x"></fa-icon>
                <ion-label>
                  <strong>{{ 'Expenses' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/chartofaccountslist')" class="menu" *ngIf="global.WithModule('ChartOfAccounts')">
                <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faFileInvoice" size="2x"></fa-icon>
                <ion-label>
                  <strong>{{ 'Chart of Accounts' }}</strong>
                </ion-label>
              </ion-item> -->

              <ion-item lines="none" button (click)="MenuRoute('/financialperiodslist')" class="menu" *ngIf="global.WithModule('FinancialPeriods')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faCalendar" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Financial Periods' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/storeslist')" class="menu" *ngIf="global.WithModule('Stores')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faStore" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Store Fronts' }}</strong>
                </ion-label>
              </ion-item>

            </ion-menu-toggle>
          </ion-list>

          <ion-item lines="none" button (click)="Toggle('Inventories');" class="menu" *ngIf="global.WithModule('WarehouseTransfers') || global.WithModule('PriceIncreases') || global.WithModule('InventoryAdjustments') || global.WithModule('StoreItemBalances') || global.WithModule('InventoryStockCards') || global.WithModule('BarcodeChecks')">
            <fa-icon slot="start" [icon]="faAngleRight" size="2x" *ngIf="!Menu['Inventories']"></fa-icon>
            <fa-icon slot="start" [icon]="faAngleDown" size="2x" *ngIf="Menu['Inventories']"></fa-icon>

            <ion-label>
              <!-- <fa-icon [icon]="faUserCircle" size="2x"></fa-icon>
              &nbsp; -->
              <strong>{{ 'INVENTORIES' }}</strong>
            </ion-label>
          </ion-item>

          <ion-list *ngIf="Menu['Inventories']" class="menu">
            <ion-menu-toggle>
              <ion-item lines="none" button (click)="MenuRoute('/warehousetransferslist')" class="menu" *ngIf="global.WithModule('WarehouseTransfers')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faMapSigns" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Warehouse Transfer' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/priceincreasesform')" class="menu" *ngIf="global.WithModule('PriceIncreases')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faChartLine" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Price Increase' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/inventoryadjustmentslist')" class="menu" *ngIf="global.WithModule('InventoryAdjustments')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faCartPlus" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Inventory Adjustment' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/storeitembalanceslist')" class="menu" *ngIf="global.WithModule('StoreItemBalances')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faBalanceScale" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Store Item Balance' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/inventorystockcardslist')" class="menu" *ngIf="global.WithModule('InventoryStockCards')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faClipboard" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Inventory Stock Card' }}</strong>
                </ion-label>
              </ion-item>

              <!-- <ion-item lines="none" button (click)="MenuRoute('/barcodecheckslist')" class="menu" *ngIf="global.WithModule('BarcodeChecks')">
                <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faUsers" size="2x"></fa-icon>
                <ion-label>
                  <strong>{{ 'Barcode Checks' }}</strong>
                </ion-label>
              </ion-item> -->
            </ion-menu-toggle>
          </ion-list>

          <ion-item lines="none" button (click)="Toggle('Sales');" class="menu" *ngIf="(global.WithModule('Quotations') || global.WithModule('SalesOrders') || global.WithModule('DeliveryReceipts') || global.WithModule('Invoices') || global.WithModule('SalesReturns') || global.WithModule('Collections') || global.WithModule('SalesCreditMemos') || global.WithModule('SalesDebitMemos') || global.WithModule('CounterReceipts'))">
            <fa-icon slot="start" [icon]="faAngleRight" size="2x" *ngIf="!Menu['Sales']"></fa-icon>
            <fa-icon slot="start" [icon]="faAngleDown" size="2x" *ngIf="Menu['Sales']"></fa-icon>

            <ion-label>
              <!-- <fa-icon [icon]="faClipboardList" size="2x"></fa-icon>
              &nbsp; -->
              <strong>{{ 'SALES' }}</strong>
            </ion-label>
          </ion-item>

          <ion-list *ngIf="Menu['Sales']" class="menu">
            <ion-menu-toggle>
              <ion-item lines="none" button (click)="MenuRoute('/quotationslist', true)" class="menu" *ngIf="global.WithModule('Quotations')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Quotations' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/salesorderslist', true)" class="menu" *ngIf="global.WithModule('SalesOrders')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Sales Orders' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/deliveryreceiptslist', true)" class="menu" *ngIf="global.WithModule('DeliveryReceipts')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Delivery Receipts' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/invoiceslist', true)" class="menu" *ngIf="global.WithModule('Invoices')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Invoices' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/salesreturnslist', true)" class="menu" *ngIf="global.WithModule('SalesReturns')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Sales Returns' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/collectionslist', true)" class="menu" *ngIf="global.WithModule('Collections')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Collections' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/salescreditmemoslist', true)" class="menu" *ngIf="global.WithModule('SalesCreditMemos')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Credit Memos' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/salesdebitmemoslist', true)" class="menu" *ngIf="global.WithModule('SalesDebitMemos')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Debit Memos' }}</strong>
                </ion-label>
              </ion-item>

              <ion-item lines="none" button (click)="MenuRoute('/counterreceiptslist', true)" class="menu" *ngIf="global.WithModule('CounterReceipts')">
                <!-- <ion-text slot="start" class="slot"></ion-text>
                <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                <ion-label>
                  <strong>{{ 'Counter Receipts' }}</strong>
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>

            <ion-item lines="none" button (click)="Toggle('Purchases');" class="menu" *ngIf="(global.WithModule('PurchaseOrders') || global.WithModule('Bills') || global.WithModule('PurchaseReturns') || global.WithModule('ProformaInvoices') || global.WithModule('Importations') || global.WithModule('Disbursements') || global.WithModule('PurchaseCreditMemos') || global.WithModule('PurchaseDebitMemos'))">
              <fa-icon slot="start" [icon]="faAngleRight" size="2x" *ngIf="!Menu['Purchases']"></fa-icon>
              <fa-icon slot="start" [icon]="faAngleDown" size="2x" *ngIf="Menu['Purchases']"></fa-icon>

              <ion-label>
                <!-- <fa-icon [icon]="faClipboardList" size="2x"></fa-icon>
                &nbsp; -->
                <strong>{{ 'PURCHASES' }}</strong>
              </ion-label>
            </ion-item>

            <ion-list *ngIf="Menu['Purchases']" class="menu">
              <ion-menu-toggle>
                <ion-item lines="none" button (click)="MenuRoute('/purchaseorderslist', true)" class="menu" *ngIf="global.WithModule('PurchaseOrders')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Purchase Orders' }}</strong>
                  </ion-label>
                </ion-item>

                <ion-item lines="none" button (click)="MenuRoute('/billslist', true)" class="menu" *ngIf="global.WithModule('Bills')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Bills' }}</strong>
                  </ion-label>
                </ion-item>

                <ion-item lines="none" button (click)="MenuRoute('/purchasereturnslist', true)" class="menu" *ngIf="global.WithModule('PurchaseReturns')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Purchase Returns' }}</strong>
                  </ion-label>
                </ion-item>

                <ion-item lines="none" button (click)="MenuRoute('/proformainvoiceslist', true)" class="menu" *ngIf="global.WithModule('ProFormaInvoices')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Pro-Forma Invoices' }}</strong>
                  </ion-label>
                </ion-item>

                <ion-item lines="none" button (click)="MenuRoute('/importationslist', true)" class="menu" *ngIf="global.WithModule('Importations')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Importations' }}</strong>
                  </ion-label>
                </ion-item>

                <ion-item lines="none" button (click)="MenuRoute('/disbursementslist', true)" class="menu" *ngIf="global.WithModule('Disbursements')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Disbursements' }}</strong>
                  </ion-label>
                </ion-item>

                <ion-item lines="none" button (click)="MenuRoute('/purchasecreditmemoslist', true)" class="menu" *ngIf="global.WithModule('PurchaseCreditMemos')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Credit Memos' }}</strong>
                  </ion-label>
                </ion-item>

                <ion-item lines="none" button (click)="MenuRoute('/purchasedebitmemoslist', true)" class="menu" *ngIf="global.WithModule('PurchaseDebitMemos')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Debit Memos' }}</strong>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>
            </ion-list>

            <ion-item lines="none" button (click)="Toggle('Consignment');" class="menu" *ngIf="(global.WithModule('Reorders') || global.WithModule('DeliveryIssuances') || global.WithModule('StorePullouts') || global.WithModule('StoreWarehouseTransfers'))">
              <fa-icon slot="start" [icon]="faAngleRight" size="2x" *ngIf="!Menu['Consignment']"></fa-icon>
              <fa-icon slot="start" [icon]="faAngleDown" size="2x" *ngIf="Menu['Consignment']"></fa-icon>

              <ion-label>
                <!-- <fa-icon [icon]="faClipboardList" size="2x"></fa-icon>
                &nbsp; -->
                <strong>{{ 'CONSIGNMENTS' }}</strong>
              </ion-label>
            </ion-item>

            <ion-list *ngIf="Menu['Consignment']" class="menu">
              <ion-menu-toggle>
                <ion-item lines="none" button (click)="MenuRoute('/reorderslist', true)" class="menu" *ngIf="global.WithModule('Reorders')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Reorders' }}</strong>
                  </ion-label>
                </ion-item>

                <ion-item lines="none" button (click)="MenuRoute('/deliveryissuanceslist', true)" class="menu" *ngIf="global.WithModule('DeliveryIssuances')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Delivery Issuances' }}</strong>
                  </ion-label>
                </ion-item>

                <ion-item lines="none" button (click)="MenuRoute('/storepulloutslist', true)" class="menu" *ngIf="global.WithModule('StorePullouts')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Store Pullouts' }}</strong>
                  </ion-label>
                </ion-item>

                <ion-item lines="none" button (click)="MenuRoute('/storewarehousetransferslist', true)" class="menu" *ngIf="global.WithModule('StoreWarehouseTransfers')">
                  <!-- <ion-text slot="start" class="slot"></ion-text>
                  <fa-icon slot="end" [icon]="faClipboardList" size="2x"></fa-icon> -->
                  <ion-label>
                    <strong>{{ 'Store Warehouse Transfers' }}</strong>
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>
            </ion-list>

        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet main>
      <uploadform></uploadform>
    </ion-router-outlet>
  </ion-split-pane>
</ion-app>
